/**
 * Utility to send custom analytics events (signup, login, pricing_view, etc.)
 * to the internal track-analytics edge function.
 */
import { sendOwnEvent } from "@/lib/ownAnalytics";

export type BusinessEvent =
  // Auth & Onboarding
  | "signup"
  | "login"
  | "logout"
  | "onboarding_started"
  | "onboarding_step_completed"
  | "onboarding_completed"
  | "first_analysis_started"
  | "first_analysis_skipped"
  // Front engagement
  | "hero_cta_clicked"
  | "scroll_depth"
  | "faq_opened"
  | "chatbot_opened"
  | "chatbot_converted"
  | "blog_article_read"
  | "social_share_clicked"
  | "language_switched"
  | "pricing_toggle"
  | "testimonial_viewed"
  | "exit_intent_shown"
  // Pricing & Checkout
  | "pricing_view"
  | "plan_selected"
  | "checkout_started"
  | "payment_completed"
  // Free CRO
  | "free_cro_started"
  | "free_cro_submitted"
  | "free_cro_v3_started"
  | "free_cro_v3_submitted"
  // Account actions
  | "project_created"
  | "analysis_started"
  | "analysis_completed"
  | "analysis_page_added"
  | "report_exported"
  | "report_shared"
  | "competitor_added"
  | "client_created"
  | "brand_profile_updated"
  | "credits_low_warning"
  | "upgrade_prompt_shown"
  | "upgrade_prompt_clicked"
  | "feature_gated"
  | "settings_changed"
  | "referral_link_copied"
  | "referral_share"
  | "export_report";

/** Counted for every real visitor; cookieless without consent (see ownAnalytics.ts). */
export async function trackBusinessEvent(
  eventType: BusinessEvent,
  eventData: Record<string, unknown> = {}
) {
  await sendOwnEvent(eventType, eventData, { pagePath: window.location.pathname });
}
